export default {
	checkConsent() {
		const consentTimestamp = localStorage.getItem("rec.privacy.consent");

		if (consentTimestamp || !$rec.privacyEnabled)
			return;

		const info = {
			content: `We use cookies to ensure you get the best experience on our website. <a href="${$rec.privacyUrl}" target="_blank">Read our Privacy notice</a>`,
			closeButtonText: "I Accept",
			onClose: () => {
				localStorage.setItem("rec.privacy.consent", parseInt(new Date().getTime() / 1000));
			}
		};

		$bus.$emit("notify", "NotificationInfo", info);
	}
};
